// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n._2rkolb4i{border-radius:var(--ds-radius-xsmall,2px)}._12y3e4h9{outline-width:var(--ds-border-width,1px)}\n._16qs1cd0{box-shadow:var(--ds-shadow-overlay,0 8px 9pt #091e4226,0 0 1px #091e424f)}\n._1e0c1ule{display:block}\n._bfhk1bhr{background-color:var(--ds-surface-overlay,#fff)}\n._mizu1p6i:focus-visible{outline-color:var(--ds-border-focused,#388bff)}\n._ra3xnqa1:focus-visible{outline-style:solid}", ""]);
// Exports
module.exports = exports;
